import { Select, SelectProps } from "@chakra-ui/react";
import { useEffect } from "react";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { useToastOnAPIError } from "../api/useToastOnAPIError";

interface TeamSelectorProps extends SelectProps {
  value: string;
  setValue: (v: string) => void;
}

export const TeamSelector = ({
  value,
  setValue,
  ...selectProps
}: TeamSelectorProps) => {
  const api = useAPI();
  const { data, error, query } = useAPIQuery({ apiCall: api.teamGet });
  useToastOnAPIError({
    error: error,
    title: `Unable to fetch teams`,
  });

  useEffect(() => {
    query({});
  }, [query]);

  return (
    <Select
      placeholder={"Select Team"}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      {...selectProps}
    >
      {(data?.teams ?? []).map((team) => (
        <option key={team.id} value={team.id}>
          {team.name}
        </option>
      ))}
    </Select>
  );
};
